<template>
  <div>
    <div>
      <div v-if="isActiveTruckerTool">
        <elds-connected />
      </div>
      <div
        v-else
        class="mb-5 text-left"
      >
        <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
          Connect your systems with {{ brokerName }}.
        </h4>
        <div
          v-if="non_deferred_integrations?.length > 0"
          class="flex flex-col gap-4"
        >
          <div
            v-for="(integration, index) in integrations"
            :key="`${integration.name}-${index}`"
            class="integration-btn cursor-pointer"
            style="padding-left: 10px"
            :class="{
              'connected-integration': data.integrations.systems.includes(
                integration.name
              ),
            }"
            :style="
              checkDeferToThankYouPage(integration) == false
                ? 'display: none'
                : ''
            "
            @click="setSelected(integration)"
          >
            <img
              v-if="
                integration.is_type === 'ascendtms' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/integrations/ascend.svg"
              alt="AscendTMS logo"
            />
            <img
              v-if="
                integration.is_type === 'mcleod' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/integrations/McLeod.png"
              alt="McLeod logo"
              class="-ml-2 mt-1"
              style="width: 120px; height: 48px"
            />
            <img
              v-if="
                integration.is_type === 'smarthop' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/integrations/smarthop.svg"
              alt="Smarthop logo"
            />
            <img
              v-if="
                integration.is_type === 'macropoint' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/macropoint.png"
              alt="Macropoint logo"
              class="h-11 w-20"
            />
            <img
              v-if="
                integration.is_type === 'fourkites' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/integrations/fourkites.svg"
              alt="Fourkites logo"
            />
            <img
              v-if="
                integration.is_type === 'keeptruckin' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/integrations/keeptruckin.svg"
              alt="KeepTruckin logo"
            />
            <img
              v-if="
                integration.is_type === 'motive' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/integrations/motive.svg"
              alt="Motive logo"
              style="height: 30px"
            />
            <img
              v-if="
                integration.is_type === 'samsara' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/integrations/samsara.svg"
              alt="Samsara logo"
              style="height: 30px"
            />
            <img
              v-if="
                integration.is_type === 'trucker_tools' &&
                checkDeferToThankYouPage(integration)
              "
              src="@/assets/integrations/trucker_tools_logo.png"
              alt="Trucker Tools logo"
              style="height: 20px"
            />

            <div class="flex px-4">
              <p
                class="mr-2"
                :class="
                  connect_subscriptions_by_name.includes(integration.name)
                    ? 'text-yellow-500'
                    : 'text-gray-over-dark'
                "
              >
                {{
                  connect_subscriptions_by_name.includes(integration.name)
                    ? 'Connected'
                    : 'Connect'
                }}
              </p>
              <img
                v-if="connect_subscriptions_by_name.includes(integration.name)"
                src="@/assets/yellow-verified.svg"
                alt="right-triangle polygon"
              />
              <img
                v-else
                src="@/assets/right-triangle.svg"
                alt="right-triangle polygon"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <empty-state-box
            text="No integrations available at this time. Please continue."
            class="rounded-md bg-off-white py-8 text-gray-over-dark"
          />
        </div>
      </div>

      <login-modal
        v-if="showModal"
        :visible="showModal"
        :integration="selected"
        :update-integrations="updateIntegrations"
        @close="onCloseModal"
      />
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      @next="handleNext"
      @back="handleBack"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { ref, computed, watch } from 'vue';
import IntegrationLoginModal from '@/components/modals/IntegrationLoginModal.vue';
import EldsConnected from '@/components/steps/Integrations/TruckerTools/EldsConnected.vue';
import EmptyStateBox from '@/components/EmptyStateBox.vue';

export default {
  name: 'Integrations',
  components: {
    FormNavigationButtons,
    'login-modal': IntegrationLoginModal,
    'elds-connected': EldsConnected,
    EmptyStateBox,
  },
  props: {
    data: Object,
    updateField: Function,
    nextStep: Function,
    formPosition: Number,
    title: String,
    stepName: String,
    skipStep: Function,
    screenSize: String,
  },
  setup(_, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Integrations';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const buttonsToDisplay = 'continue-save';
    const isButtonDisabled = false;

    const company_question_sections = computed(
      () => store.state.carriers.carrierData?.company_question_sections || []
    );
    const auto_skip_stage_six = computed(
      () => store.state.carriers.carrierData?.auto_skip_stage_six || false
    );
    const auto_skip_stage_seven = computed(
      () => store.state.carriers.carrierData?.auto_skip_stage_seven || false
    );

    const setQuestionSectionIndexToLast = async () => {
      await store.commit(
        'questions/setSection',
        store.state.questions.total_sections
      );
      await store.commit(
        'questions/setSectionIndex',
        store.state.questions.total_sections - 1
      );
    };

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToNextStep();
    };

    // backChecks: Checks to be reviewed when the user clicks the Back button (but before any store.state.formRoutes.activeStep changes)
    const backCheck1 = computed(
      () => store.state.integrations?.truckerTools?.isActive
    );
    const backCheck2 = computed(
      () =>
        (!company_question_sections.value?.length ||
          auto_skip_stage_seven.value) &&
        auto_skip_stage_six.value
    );
    const backCheck3 = computed(
      () =>
        (!company_question_sections.value?.length ||
          auto_skip_stage_seven.value) &&
        (store.state.payments.payment_type === 'factoring' ||
          !!store.state.carriers.carrierData?.payment_method)
    );
    const backCheck4 = computed(
      () =>
        !company_question_sections.value?.length || auto_skip_stage_seven.value
    );

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );

      if (backCheck1.value) {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck1 is TRUE (truckerTools is active), setting truckerTools to false and returning'
        );
        return store.commit('integrations/setActiveTruckerTools', false);
      } else {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck1 is FALSE (truckerTools is not active)'
        );
      }

      if (backCheck2.value) {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck2 is TRUE (auto_skip_steps: 6 is true, 7 is true or no quesiton sections), moving to Insurance-4'
        );
        return formRouter.moveToStepByIdentifier('Insurance-4');
      } else {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck2 is FALSE (not auto-skipping Questions and Payment steps)'
        );
      }

      if (backCheck3.value) {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck3 is TRUE (auto_skip_stages: 7 is true (or no company question sections), and either payment_type is factoring or a payment_method exists), skipping Questions and moving to Payment-2'
        );
        return formRouter.moveToStepByIdentifier('Payment-2');
      } else {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck3 is FALSE (not auto-skipping Questions to Payment-2)'
        );
      }

      if (backCheck4.value) {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck4 is TRUE (auto_skip_stages: 7 is true (or no company question sections)), skipping Questions and moving to Payment-2'
        );
        return formRouter.moveToStepByIdentifier('Payment-2');
      } else {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck4 is FALSE (Not skipping Integrations and Questions to Payment-2)'
        );
      }

      setQuestionSectionIndexToLast();
      formRouter.moveToPreviousStep();
    };

    const redirectCheck = computed(() => {
      // auto_skip_stage_eight Redirect Check
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ': Redirect check (auto_skip_stage_eight)'
      );
      if (store.state.carriers?.carrierData?.auto_skip_stage_eight) {
        store.commit(
          'addFormDebugMessage',
          'REDIRECT | ' +
            componentIdentifier +
            ': Redirect needed (auto_skip_stage_eight), redirecting to Contract-1'
        );
        return 'Contract-1';
      }
      return false;
    });

    watch(isNavigationDisabled, (val) => {
      if (val == false) {
        store.commit(
          'addFormDebugMessage',
          'CHECK | ' +
            componentIdentifier +
            ': (isNavigationDisabled watcher) ' +
            componentIdentifier +
            ' is active step, running redirect checks'
        );
        if (redirectCheck.value !== false) {
          handleRedirect(redirectCheck.value);
        }
      }
    });

    const handleRedirect = (val) => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleRedirect' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToStepByIdentifier(val);
    };

    const showModal = ref(false);

    const openModal = () => {
      showModal.value = true;
    };
    const onCloseModal = () => {
      showModal.value = false;
    };

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      openModal,
      showModal,
      onCloseModal,
      emitExitModal,
    };
  },
  data() {
    return {
      selected: '',
    };
  },
  computed: {
    isActiveTruckerTool() {
      return this.$store.state.integrations?.truckerTools?.isActive;
    },
    carrierId() {
      return this.$store.state.carriers?.carrierDetails?.id;
    },
    brokerName() {
      return this.$store.state.brokers?.logo?.legal_name;
    },
    packetId() {
      return this.$store.state.onboardingPacket?.id;
    },
    issuerId() {
      return this.$store.state.carriers.carrierData?.connection?.issuer_id;
    },
    integrations() {
      return this.$store.state.onboardingPacket?.broker_connect_channels;
    },
    non_deferred_integrations() {
      if (!this.integrations) return [];
      if (this.integrations?.length < 1) return [];
      let all_integrations = [...this.integrations];
      let is_types =
        this.$store.state.onboardingPacket
          ?.post_onboard_broker_channel_is_types;
      return all_integrations.filter(
        (integration) =>
          !(
            is_types.includes(integration?.is_type) &&
            !integration.is_shown_in_integrations_step
          )
      );
    },
    connect_subscriptions() {
      return this.$store.state.onboardingPacket?.connect_subscriptions;
    },
    connect_subscriptions_by_name() {
      let returnVal = [];
      if (this.connect_subscriptions) {
        this.connect_subscriptions.forEach(function (el) {
          returnVal.push(el?.channel?.name);
        });
      }
      return returnVal;
    },
  },
  beforeMount() {
    this.$store.dispatch('onboardingPacket/getConnectSubscriptions');
  },
  methods: {
    async setSelected(item) {
      //Trucker tools need to render another additionals screens the ID is 25,
      if (item?.is_type === 'trucker_tools') {
        await this.$store.dispatch('integrations/getCarrierElds', item.id);
        this.$store.commit('integrations/setActiveTruckerTools', true);
        this.$store.commit('integrations/setTruckerToolChannelId', item.id);
      } else {
        this.selected = item?.name;
        let thisPage = window.location.href;
        window.location.href = `${item.initialization_url}?redirect_url=${thisPage}`;
      }
    },
    updateNestedField(path, value) {
      this.$store.commit('updateNestedField', { path, value });
    },
    updateIntegrations(path, value) {
      let newArray =
        this.data.integrations.systems.indexOf(value) === -1
          ? [...this.data.integrations.systems, value]
          : this.data.integrations.systems;
      this.updateNestedField(path, newArray);
    },
    checkDeferToThankYouPage(integration) {
      let is_types =
        this.$store.state.onboardingPacket
          ?.post_onboard_broker_channel_is_types;
      if (is_types.includes(integration?.is_type)) {
        return integration?.is_shown_in_integrations_step;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.integration-btn {
  @apply flex items-center justify-between rounded-md border border-light-gray p-2;
  height: 54px;
}

.connected-integration {
  box-shadow: 0px 5px 10px rgba(248, 198, 23, 0.3);
  @apply rounded-md border-2 border-yellow-500;
}
</style>
